export const HOME_SECTIONS = [
  { id: "animation", label: "Animation accueil" },
  { id: "promotions", label: "Promotions" },
  { id: "services", label: "Services" },
  { id: "vehicle", label: "Choix du véhicule" },
  { id: "flexfuel_calculator", label: "Calculateur Flexfuel" },
  { id: "flexfuel_faq", label: "FAQ Flexfuel" },
  { id: "gallery", label: "Galerie" },
  { id: "marquee", label: "Bandeau défilant" },
  { id: "google_reviews", label: "Avis Google" },
  { id: "testimonials", label: "Témoignages" },
  { id: "seo_editorial", label: "Texte SEO", warning: "Masquer ce texte peut faire baisser votre référencement Google." },
  { id: "booking", label: "Prise de rendez-vous", locked: true },
];

const META = Object.fromEntries(HOME_SECTIONS.map((s) => [s.id, s]));

export const homeSectionMeta = (id) => META[id];

// Stored CMS order (may be partial/outdated) → full ordered list; new sections appended, locked ones always visible.
export const resolveHomeSections = (stored) => {
  const seen = new Set();
  const list = (Array.isArray(stored) ? stored : []).filter((s) => META[s?.id] && !seen.has(s.id) && seen.add(s.id));
  return [...list, ...HOME_SECTIONS.filter((s) => !seen.has(s.id))].map((s) => ({
    id: s.id,
    visible: META[s.id].locked ? true : s.visible !== false,
  }));
};
